import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>ID</div>
            <div>Оператор</div>
            <div>Тариф</div>
            <div>Дата завершення</div>
        </div>
    )
}